export default __webpack_public_path__ + "static/media/Doink_Cards_Coupon.d10825b3.png";